import { t } from 'i18next';

export enum FileType {
  JKS_KEYSTORE = 'JKS_KEYSTORE',
  JCEKS_KEYSTORE = 'JCEKS_KEYSTORE',
  PKCS12_KEYSTORE = 'PKCS12_KEYSTORE',
  CERTIFICATE = 'CERTIFICATE',
  PKCS1_KEY = 'PKCS1_KEY',
  PKCS8_KEY = 'PKCS8_KEY',
  SSH_KEY = 'SSH_KEY',
  PPK = 'PPK',
  X509_KEY = 'X509_KEY',
  PGP_KEY = 'PGP_KEY',
  OTHER_KEY = 'OTHER_KEY',
  JAR = 'JAR',
  SHARED_LIB = 'SHARED_LIB',
  SST_KEYSTORE = 'SST_KEYSTORE',
  PKCS7 = 'PKCS7',
  UNKNOWN = 'UNKNOWN',
}

export const getFileTypeLabel = (fileType: FileType): string => {
  const labels = {
    [FileType.JKS_KEYSTORE]: t('fileTypeLabel.jksKeystore'),
    [FileType.JCEKS_KEYSTORE]: t('fileTypeLabel.jceksKeystore'),
    [FileType.PKCS12_KEYSTORE]: t('fileTypeLabel.pkcs12Keystore'),
    [FileType.CERTIFICATE]: t('fileTypeLabel.certificate'),
    [FileType.PKCS1_KEY]: t('fileTypeLabel.pkcs1Key'),
    [FileType.PKCS8_KEY]: t('fileTypeLabel.pkcs8Key'),
    [FileType.SSH_KEY]: t('fileTypeLabel.sshKey'),
    [FileType.PPK]: t('fileTypeLabel.ppk'),
    [FileType.X509_KEY]: t('fileTypeLabel.x509Key'),
    [FileType.PGP_KEY]: t('fileTypeLabel.pgpKey'),
    [FileType.OTHER_KEY]: t('fileTypeLabel.otherKey'),
    [FileType.JAR]: t('fileTypeLabel.jar'),
    [FileType.SHARED_LIB]: t('fileTypeLabel.sharedLib'),
    [FileType.SST_KEYSTORE]: t('fileTypeLabel.sstKeystore'),
    [FileType.PKCS7]: t('fileTypeLabel.pkcs7'),
    [FileType.UNKNOWN]: t('fileTypeLabel.unknown'),
  };

  return labels[fileType] || fileType;
};
